export const COMPONENT_MAP  = {
    DATE_RANGE_PICKER : 'DATE_RANGE_PICKER',
    DATE_PICKER: 'DATE_PICKER',
    BRANCH_FILTER: 'BRANCH_FILTER',
    BRAND_NAME: 'BRAND_NAME',
    GROUP_BY : 'GROUP_BY'
}